import ApiUrl from "../../../helpers/ApiUrl";
import { get } from "../../../helpers/ApiServices";

export const landingPageReportApi = {
  async getLandingPageCompletionMetrics() {
    try {
      const response = await get(ApiUrl.getLandingPageCompletionMetrics, "", "");
      return { success: true, data: { result: response.data.result } };
    } catch (error) {
      return {
        success: false,
        data: {
          message: error.message || "Failed to fetch landingPage completion metrics"
        }
      };
    }
  },

  async getLandingPageTotalCompletion(landingPageId) {
    try {
      const response = await get(
        ApiUrl.getLandingPageTotalCompletion + landingPageId,
        "",
        ""
      );
      return { success: true, data: { result: response.data.result } };
    } catch (error) {
      return {
        success: false,
        data: {
          message: error.message || "Failed to fetch landing page total completion"
        }
      };
    }
  },

  async getLandingPageCompletionDetail(landingPageId) {
    try {
      const response = await get(ApiUrl.getLandingPageCompletionMetrics + landingPageId, "", "");
      return { success: true, data: { result: response.data.result } };
    } catch (error) {
      return {
        success: false,
        data: { message: error.message || "Failed to fetch landing page completion detail" }
      };
    }
  },
  async getLandingPageCompletionResponses(id) {
    try {
      const response = await get(ApiUrl.getLandingPageMetrics + id, "", "");
      return { success: true, data: { result: response.data.result } };
    } catch (error) {
      return { success: false, data: { message: error.message || "Failed to fetch landing page completion responses" } };
    }
  }
};
